import { useLocation, Navigate, Outlet } from "react-router-dom";
import useAuth from "./useAuth";

export default function UserAuthenticate() {
    const { auth, loading } = useAuth();
    const location = useLocation();
    
    // Show nothing while checking authentication status
    if (loading) {
        return null;
    }
    
    // Redirect to login if not authenticated
    if (!auth.isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }
    
    // User is authenticated, render the protected routes
    return <Outlet />;
}
